import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LoginRequest } from '../interfaces/usuario';
// import { User } from '../core/intefaces/user';

export interface UserToken {
  accessToken: string;
  expiresIn?: number;
  usuarioToken: {
    id: string;
    email: string;
    claims: Array<{
      value: string;
      type: string;
    }>
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {


  private identidade = environment.api.identidade;
  // private uploads = environment.uploads;

  constructor(private http: HttpClient, private router: Router) { }

  async login(form: LoginRequest, remember: boolean = false) {
    return this.http.post<UserToken>(`${this.identidade}autenticar`, form).toPromise();
  }

  getUser() {
    return localStorage.getItem('last_login_user') ? JSON.parse(localStorage.getItem('last_login_user')) : '';
  }

  getUserId(usuario) {
    return this.http.get(`usuario/${usuario}`).toPromise();
  }

  getFuncionarioId(funcionarioId) {
    return this.http.get(`funcionario/por-usuario/${funcionarioId}`).toPromise();
  }


  getAvatarUser(user) {
    return user.fotoUsuario ? user.fotoUsuario : '/assets/user_avatar.png';
  }

  // form: { id, senha, senhaConfirmacao }
  updatePassword(form) {
    return this.http.put<any>(this.identidade.replace(/\/$/, ''), form).pipe();
  }

  // form: { id, emailNovo } — altera também o login do usuário
  updateEmail(form: { id: string, emailNovo: string }) {
    return this.http.put<any>(`${this.identidade}atualizar-email`, form).toPromise();
  }

  forgotPassword(email) {
    return this.http.get<any>(`Usuario/getNovaSenha?strEmail=${email}`).toPromise();
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
